module.exports = __webpack_public_path__ + "static/media/bravo_de-niro.d18658a3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/static/gif/bravo_de-niro.gif
// module id = 702
// module chunks = 0